import React from 'react';
import { Context, Wrap } from './ContextImage.style';

const ContextImage = ({ context, image }) => (
  <Wrap>
    {image && image.localFile && (
      <picture>
        <source
          srcSet={image.localFile.childImageSharp.fluid.srcSetWebp}
          type="image/webp"
        />
        <source
          srcSet={image.localFile.childImageSharp.fluid.srcSet}
          type="image/jpeg"
        />
        <img
          src={image.localFile.childImageSharp.fluid.src}
          alt={image.alt_text}
          loading="lazy"
        />
      </picture>
    )}
    <Context y={[30, -30]}>
      <div className="inner">
        {context &&
          context.map((c, i) => (
            <dl key={i}>
              <dt>{c.label}</dt>
              <dd>{c.waarde}</dd>
            </dl>
          ))}
      </div>
    </Context>
  </Wrap>
);

export default ContextImage;
